// ES6 experiment
/*
 * You gotta use `type="module"` :
 *    <script type="module" src="basic.js"></script>
 * for this module to work
 */

import {CSCS} from './CSCS.js';  // used with named export: "export let CSCS = {..."
import './tmerc.js';  // this isn't importing anything, it adds `merc` to the CSCS object
import './merc.js';  // this isn't importing anything, it adds `merc` to the CSCS object
import './defs/rwg-favorites.js';  // this isn't importing anything, it adds `merc` to the CSCS object

/*
// Wyoming
CSCS.list.EPSG3736 = "+title=NAD83 Wyoming East (ftUS) +proj=tmerc +lat_0=40.5  +lon_0=-105.1666666666667 +k=0.9999375 +x_0=200000.0 +y_0=0.0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192";
CSCS.list.EPSG3737 = "+title=NAD83 Wyoming East Central USft +proj=tmerc +lat_0=40.5  +lon_0=-107.3333333333333 +k=0.9999375 +x_0=400000 +y_0=100000 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192";
CSCS.list.EPSG3738 = "+title=NAD83 Wyoming West Central USft +proj=tmerc +lat_0=40.5  +lon_0=-108.75 +k=0.9999375 +x_0=600000 +y_0=0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192";
CSCS.list.EPSG3739 = "+title=Wyoming West NAD83 USft +proj=tmerc +lat_0=40.5 +lon_0=-110.0833333333333 +k=0.9999375 +x_0=800000 +y_0=100000 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192";

// Idaho
CSCS.list.EPSG2241 =  "+title=NAD83 Idaho East (ftUS) +proj=tmerc +lat_0=41.66666666666666 +lon_0=-112.1666666666667 +k=0.999947 +x_0=200000 +y_0=0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192";
CSCS.list.EPSG2242 =  "+title=NAD83 Idaho Central (ftUS) +proj=tmerc +lat_0=41.66666666666666 +lon_0=-114 +k=0.999947 +x_0=500000 +y_0=0 +a=6378137.0 +b=6356752.3141403 +towgs84=0,0,0,0,0,0,0 +to_meter=0.3048006096012192";
*/
/*
// UTM
CSCS.utm.zone(11);
CSCS.utm.zone(12);
CSCS.utm.zone(13);
CSCS.utm.zone(17);
*/

// CSCS.list.EPSG3857 = "+title=WGS 84 Pseudo-Mercator +proj=merc +a=6378137 +b=6378137 +lat_ts=0.0 +lon_0=0.0 +x_0=0.0 +y_0=0 +k=1.0 +to_meter=1";

export {CSCS} from './CSCS.js';
